export default {
    SET_CATEGORIES(state,categories){  state.Categories = categories; },
    SET_BRANDS(state,brands){  state.brands = brands; },
    SET_PRODUCT_DATA(state,product){  state.product = product},
    SET_PRODUCTS_DATA(state,products){  state.products = products},
    SET_META_DATA(state, payload) {
        state.meta = payload;
      },
}
